var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 3.22133e-08 18.2091 0 16V7H5.33301C5.7012 7 6 6.77614 6 6.5C6 6.22386 5.7012 6 5.33301 6H0V5H3.5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4H0C0 1.79086 1.79086 3.22128e-08 4 0H16Z",
    fill: "url(#paint0_linear_2106_295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49908 15C7.16636 15 7 14.8551 7 14.5652C7 14.4053 7.03914 14.2454 7.11743 14.0855C7.19572 13.9955 7.56758 13.5757 8.23303 12.8261C8.90826 12.0665 9.52966 11.3268 10.0972 10.6072C8.76636 8.48826 7.91988 7.10395 7.5578 6.45427C7.50887 6.33433 7.4844 6.2044 7.4844 6.06447C7.4844 5.91454 7.55291 5.76462 7.68991 5.61469C7.8367 5.46477 7.99817 5.38981 8.17431 5.38981C8.36024 5.38981 8.50703 5.47476 8.61468 5.64468C9.59327 7.28386 10.381 8.57821 10.978 9.52774C11.9957 8.30835 12.9596 6.94903 13.8697 5.44978C14.0361 5.14993 14.2709 5 14.5743 5C14.6917 5 14.7896 5.03998 14.8679 5.11994C14.956 5.18991 15 5.27986 15 5.38981C15 5.49975 14.9706 5.63968 14.9119 5.8096C14.178 7.05897 13.082 8.62319 11.6239 10.5022C12.4654 11.8816 13.2434 12.996 13.9578 13.8456C14.0361 14.0055 14.0752 14.1554 14.0752 14.2954C14.0752 14.4353 14.0018 14.5802 13.855 14.7301C13.718 14.8801 13.5615 14.955 13.3853 14.955C13.2092 14.955 13.0575 14.905 12.9303 14.8051C12.4899 14.2354 11.756 13.1559 10.7284 11.5667C10.0728 12.3563 9.13823 13.4408 7.92477 14.8201C7.7682 14.94 7.6263 15 7.49908 15Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2106_295",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAch);
export default __webpack_public_path__ + "static/media/X_ACH.bf42b98b57783976e4f654a592fa033f.svg";
export { ForwardRef as ReactComponent };